import styled from 'styled-components';
import { parseISOZonedDate } from 'utils/date';
import words from 'lodash/words';
import capitalize from 'lodash/capitalize';
import { colors, Caption } from 'ui/theme';
import { format, formatDistanceToNow } from 'date-fns';

import { useCriteriaRetentionContext } from './CriteriaRetentionContext';
import { CONTENT } from './constants';
import { Tooltip } from 'ui/tooltip';

const StyledLastModified = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const LastModified = () => {
  const { anonUserCriteriaSettings } = useCriteriaRetentionContext();

  if (
    !anonUserCriteriaSettings?.retentionPolicyUpdatedAt ||
    !anonUserCriteriaSettings?.retentionPolicyUpdatedBy
  ) {
    return null;
  }
  const timestampDate = parseISOZonedDate(
    anonUserCriteriaSettings.retentionPolicyUpdatedAt.timestamp,
  ).toDate();
  const relativeTime = formatDistanceToNow(timestampDate, { addSuffix: true });

  // Extract username from email and format as display name
  const userEmail = anonUserCriteriaSettings.retentionPolicyUpdatedBy;
  const username = userEmail.split('@')[0];
  const userName = words(username).map(capitalize).join(' ');

  return (
    <StyledLastModified>
      {CONTENT.lastModified.prefix}
      <Tooltip
        isUnderlined
        tooltipContent={
          <>
            {format(timestampDate, 'MM/dd/yyyy, h:mm a')}
            <br />
            by {userName || userEmail}
          </>
        }
      >
        {relativeTime}
      </Tooltip>
    </StyledLastModified>
  );
};
